import { createSlice } from "@reduxjs/toolkit";
import { isCloverApplePaySupported } from "./helper";
import _ from "lodash";

const initialState = {
    enabled: false,
    pakmsKey: "",
    clientId: "",
    merchantId: "",
    isCloverLive: false,
    cloverApplePayEnabled: false,
    cloverGooglePayEnabled: false,
    cloverCreditCardEnabled: false,
    clover3DSEnabled: false,
    cloverClient: false,
    // created charge id and order id which will be used in validating clover 3ds process
    chargeId: "",
    orderId: "",
    shouldRefreshSDK: false,
}

const clover = createSlice({
    name: "clover",
    initialState,
    reducers: {
        setState: (state, { payload }) => {
            state = Object.assign(state, payload);
        },
        getCloverTokenSuccess: (state, { payload }) => {
            state.enabled = _.get(payload, "records.clover_enabled", false);
            state.pakmsKey = _.get(payload, "records.clover_pakms_key", "");
            state.clientId = _.get(payload, "records.clover_client_id", "");
            state.merchantId = _.get(payload, "records.clover_merchant_id", "");
            state.isCloverLive = _.get(payload, "records.clover_is_live", false);
            state.cloverApplePayEnabled = _.get(payload, "records.clover_apple_enabled", false) && isCloverApplePaySupported();
            state.cloverGooglePayEnabled = _.get(payload, "records.clover_google_enabled", false);
            state.cloverCreditCardEnabled = _.get(payload, "records.clover_credit_card_enabled", false);
            state.clover3DSEnabled = _.get(payload, "records.clover_3ds_eanbled", false);
        }
    },
});

export const { setState, getCloverTokenSuccess } = clover.actions;

export default clover.reducer;

